/* tslint:disable */
export const CALENDAR_FR: any = {
    'firstDayOfWeek': 1,
    'dayNames': ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
    'dayNamesShort': ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'],
    'dayNamesMin': ['D', 'L', 'MA', 'ME', 'J', 'V', 'S'],
    'monthNames': ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    'monthNamesShort': ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Dec']
};
export const CALENDAR_EN: any = {
    'firstDayOfWeek': 1,
    'dayNames': ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
    'dayNamesShort': ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
    'dayNamesMin': ['SU', 'M', 'TU', 'W', 'TH', 'F', 'SA'],
    'monthNames': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    'monthNamesShort': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/calendar/calendar.constants.ts